const createStoreConfig = (
    selector: string,
    action: string,
    parentDom = 'body'
) => ({
    selector,
    type: '点击预约',
    action,
    label: action,
    parentDom,
    once: true,
    storageKey: `click_pre_btn`,
    isPopup: false,
})

export const COMMON_STORE_CONFIG = [
    createStoreConfig('.kv-store .btn-ios', '首页跳转App Store', '.section-kv'),
    createStoreConfig(
        '.kv-store .btn-gp',
        '首页跳转Google Play',
        '.section-kv'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="reward"] .btn-ios',
        '预约奖励板块跳转App Store'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="reward"] .btn-gp',
        '预约奖励板块跳转Google Play'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="world"] .btn-ios',
        '世界觀板块跳转App Store'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="world"] .btn-gp',
        '世界觀板块跳转Google Play'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="role"] .btn-ios',
        '角色介紹板块跳转App Store'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="role"] .btn-gp',
        '角色介紹板块跳转Google Play'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="feature"] .btn-ios',
        '商店圖板块跳转App Store'
    ),
    createStoreConfig(
        '.floatbar[data-track-section="feature"] .btn-gp',
        '商店圖板块跳转Google Play'
    ),
    // createStoreConfig(
    //     '.reservation-popup.popup-from-mandatory .popup-btn-reservation[data-store-type="ios"]',
    //     '開屏彈窗跳轉App Store'
    // ),
    // createStoreConfig(
    //     '.reservation-popup.popup-from-mandatory .popup-btn-reservation[data-store-type="gp"]',
    //     '開屏彈窗跳轉Google Play'
    // ),
    createStoreConfig(
        '.reservation-popup.popup-from-twenty-seconds .popup-btn-reservation[data-store-type="ios"]',
        '開屏彈窗跳轉App Store（停留20s）'
    ),
    createStoreConfig(
        '.reservation-popup.popup-from-twenty-seconds .popup-btn-reservation[data-store-type="gp"]',
        '開屏彈窗跳轉Google Play（停留20s）'
    ),
    createStoreConfig(
        '.reservation-popup.popup-from-scroll .popup-btn-reservation[data-store-type="ios"]',
        '開屏彈窗跳轉App Store（角色頁彈出）'
    ),
    createStoreConfig(
        '.reservation-popup.popup-from-scroll .popup-btn-reservation[data-store-type="gp"]',
        '開屏彈窗跳轉Google Play（角色頁彈出）'
    ),
]

export const MB_STORE_CONFIG = [...COMMON_STORE_CONFIG]
export const PC_STORE_CONFIG = [...COMMON_STORE_CONFIG]

export const MB_CONFIG = []
export const PC_CONFIG = []
